module.exports = __webpack_public_path__ + "static/img/flowered-1.13b0212.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/flowered-1.jpg
// module id = 938X
// module chunks = 1